/*! @azure/msal-common v16.4.0 2026-03-27 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.4.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
